import { Text, Center, Box } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';
import { getQuotesErrorMessage } from '../../../../common/src/utils/quotesUtils';
import SingleOfferErrorMessagePopover from '../offers/SingleOfferErrorMessagePopover';

interface Props {
  httpCode: number;
  message?: string;
}

const QuoteErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({
  httpCode,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <Center flexDir="column">
      <Text color="danger.main" textAlign="center">
        {t('SALES-CONVERSATION_OFFERS_QUOTE-ERROR-MESSAGE')}
      </Text>
      {!isSocialLoginUrl && (
        <Box mt="1">
          <SingleOfferErrorMessagePopover
            errorMessage={getQuotesErrorMessage(httpCode, message)}
          />
        </Box>
      )}
    </Center>
  );
};

export default QuoteErrorMessage;
